import { createStyles } from '@codeleap/styles'
import { SectionFiltersComposition } from '@codeleap/web'
import { StyleRegistry } from '../styles'
import { textVariant } from './Text'

const createSectionFiltersVariant = createStyles<SectionFiltersComposition>

export const SectionFiltersStyles = {
  default: createSectionFiltersVariant(theme => ({
    wrapper: {
      ...theme.presets.column,
    },
    innerWrapper: {
      ...theme.spacing.paddingBottom(0),
      ...theme.presets.column,
      ...theme.presets.fullWidth,
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    label: {
      ...textVariant('p2'),
      ...theme.spacing.marginBottom(1),
    },
    optionWrapper: {
      ...theme.presets.column,
    },
    optionInnerWrapper: {
      ...theme.presets.column,
    },
    itemOptionButtonWrapper: {
      ...theme.spacing.marginBottom(1),
      ...theme.spacing.padding(1.5),
      borderRadius: theme.radius.regular,
      backgroundColor: theme.baseColors.neutralSolid200,

      '&:hover': {
        backgroundColor: theme.baseColors.primarySolid500,
      },
      '&:hover > p': {
        color: theme.baseColors.neutralSolid0,
        fontWeight: 'bold',
      },
    },
    'itemOptionButtonWrapper:selected': {
      backgroundColor: theme.baseColors.primarySolid400,
      p: {
        color: theme.baseColors.neutralSolid0,
        fontWeight: 'bold',
      },
    },
    footerWrapper: {
      gap: theme.spacing.value(1),
    },
    applyButtonWrapper: {
      ...theme.spacing.marginBottom(3),
      ...theme.spacing.marginTop(1),
      ...theme.spacing.padding(2),
      ...theme.presets.fullWidth,
    },
    applyButtonText: {
      ...textVariant('p2'),
      color: theme.baseColors.neutralSolid0,
    },
    clearButtonWrapper: {
      ...theme.spacing.marginBottom(3),
      ...theme.spacing.marginTop(1),
      ...theme.spacing.padding(2),
      ...theme.presets.fullWidth,
    },
    clearButtonText: {
      ...textVariant('p2'),
      color: theme.baseColors.neutralSolid0,
    },
  })),
}

StyleRegistry.registerVariants('SectionFilters', SectionFiltersStyles)
